export default [
  'md-icon-user-group-filled',
  'md-icon-save-outline',
  'md-icon-s-data',
  'md-icon-uncheckbox-outline',
  'md-icon-checkbox-filled',
  'md-icon-checkbox-outline',
  'md-icon-midea-connect-filled',
  'md-icon-midea-connect-outline',
  'md-icon-account-outline',
  'md-icon-number-filled',
  'md-icon-number-outline',
  'md-icon-cellphone-filled',
  'md-icon-cellphone-outline',
  'md-icon-carriage-return-outline',
  'md-icon-database-outline',
  'md-icon-table-filled',
  'md-icon-warning-outline',
  'md-icon-warning',
  'md-icon-minus',
  'md-icon-plus',
  'md-icon-check',
  'md-icon-close',
  'md-icon-position-filled',
  'md-icon-upload-filled',
  'md-icon-share-filled',
  'md-icon-move-outline',
  'md-icon-indent-list-outline',
  'md-icon-hierarchical-list-outline',
  'md-icon-s-fold',
  'md-icon-edit',
  'md-icon-table-line',
  'md-icon-s-unfold',
  'md-icon-column-list-outline',
  'md-icon-document',
  'md-icon-document-copy',
  'md-icon-data-line',
  'md-icon-delete',
  'md-icon-edit-outline',
  'md-icon-fold-outline',
  'md-icon-pie-chart',
  'md-icon-dot-chart-outline',
  'md-icon-line-chart',
  'md-icon-add-sell-outline',
  'md-icon-apply-save-outline',
  'md-icon-crop',
  'md-icon-code-outline',
  'md-icon-download',
  'md-icon-exchange-outline',
  'md-icon-change-network-outline',
  'md-icon-full-screen',
  'md-icon-more-2',
  'md-icon-import-outline',
  'md-icon-more',
  'md-icon-customer-service-outline',
  'md-icon-export-outline',
  'md-icon-paperclip',
  'md-icon-data-check-outline',
  'md-icon-supply-chain-outline',
  'md-icon-invisible-outline',
  'md-icon-relation-outline',
  'md-icon-unordered-list-outline',
  'md-icon-date-time-outline',
  'md-icon-undo-outline',
  'md-icon-link',
  'md-icon-separate-outline',
  'md-icon-warehouse-search-outline',
  'md-icon-loading',
  'md-icon-refresh-right',
  'md-icon-refresh-left',
  'md-icon-refresh-all-outline',
  'md-icon-refresh-cache-outline',
  'md-icon-reset-time-outline',
  'md-icon-reset-outline',
  'md-icon-update-outline',
  'md-icon-refresh-select-outline',
  'md-icon-traffic-return-outline',
  'md-icon-abandon-cance-outline',
  'md-icon-delete-user-outline',
  'md-icon-mall-user-outline',
  'md-icon-change-user-outline',
  'md-icon-add-user-outline',
  'md-icon-package-return-outline',
  'md-icon-package-receive-outline',
  'md-icon-package-search-outline',
  'md-icon-package-end-outline',
  'md-icon-package-select-outline',
  'md-icon-setting-text-outline',
  'md-icon-edit-text-outline',
  'md-icon-invalid-text-outline',
  'md-icon-disable-text-outline',
  'md-icon-pass-text-outline',
  'md-icon-bill-text-outline',
  'md-icon-organization-text-outline',
  'md-icon-return-text-outline',
  'md-icon-search-text-outline',
  'md-icon-add-text-outline',
  'md-icon-share-text-outline',
  'md-icon-shopping-cart-text-outline',
  'md-icon-warning-text-outline',
  'md-icon-rollback-text-outline',
  'md-icon-text-help-outline',
  'md-icon-upload-text-outline',
  'md-icon-favorite-text-outline',
  'md-icon-view-text-outline',
  'md-icon-tool-text-outline',
  'md-icon-refresh-text-outline',
  'md-icon-share-outline',
  'md-icon-position',
  'md-icon-upload-outline',
  'md-icon-video-play-outline',
  'md-icon-unlock',
  'md-icon-view',
  'md-icon-camera',
  'md-icon-bell',
  'md-icon-chat-line-square',
  'md-icon-check-outline',
  'md-icon-collection-tag',
  'md-icon-close-notification',
  'md-icon-comment-outline',
  'md-icon-contacts-outline',
  'md-icon-daohang-line',
  'md-icon-Damagedphotos-outline',
  'md-icon-copy-receipts-outline',
  'md-icon-discover',
  'md-icon-create-invoice-outline',
  'md-icon-date',
  'md-icon-Face-line',
  'md-icon-eceive-file-outline',
  'md-icon-filler-outline',
  'md-icon-folder',
  'md-icon-folder-opened',
  'md-icon-finance-outline',
  'md-icon-happy-linebeifen',
  'md-icon-Invisible-line',
  'md-icon-lock',
  'md-icon-freeze-circle-outline',
  'md-icon-key',
  'md-icon-home-outline',
  'md-icon-location-outline',
  'md-icon-message',
  'md-icon-medal-1',
  'md-icon-menu-outline',
  'md-icon-network-outline',
  'md-icon-notebook-1',
  'md-icon-microphone',
  'md-icon-open-outline',
  'md-icon-odometer',
  'md-icon-organization-line',
  'md-icon-picture-outline',
  'md-icon-postcard',
  'md-icon-push-outline',
  'md-icon-printer',
  'md-icon-receiving',
  'md-icon-receipts-outline',
  'md-icon-search',
  'md-icon-setting',
  'md-icon-shopping-cart-2',
  'md-icon-share-2-outline',
  'md-icon-sound-mute-outline',
  'md-icon-sound-outline',
  'md-icon-spreadsheet-outline',
  'md-icon-suitcase',
  'md-icon-sync-outline',
  'md-icon-star-off',
  'md-icon-theme-outline',
  'md-icon-takeaway-box',
  'md-icon-tickets',
  'md-icon-unhappy-line',
  'md-icon-turn-off-microphone',
  'md-icon-timer',
  'md-icon-tool-outline',
  'md-icon-truck',
  'md-icon-video-camera',
  'md-icon-user',
  'md-icon-chat-line-square-filled',
  'md-icon-camera-solid',
  'md-icon-collection-tag-filled',
  'md-icon-contacts-filled',
  'md-icon-copy-receipts-filled',
  'md-icon-close-notification-filled',
  'md-icon-create-invoice-filled',
  'md-icon-date-filled',
  'md-icon-Damagedphotos-filled',
  'md-icon-discover-filled',
  'md-icon-Face-filled',
  'md-icon-filler-filled',
  'md-icon-finance-filled',
  'md-icon-eceive-file-filled',
  'md-icon-folder-filled',
  'md-icon-folder-opened-filled',
  'md-icon-freeze-circle-filled',
  'md-icon-happy-line',
  'md-icon-Halfstar-filled',
  'md-icon-key-filled',
  'md-icon-Invisible-filled',
  'md-icon-lock-filled',
  'md-icon-location',
  'md-icon-medal-1-filled',
  'md-icon-message-filled',
  'md-icon-microphone-filled',
  'md-icon-message-solid',
  'md-icon-menu',
  'md-icon-network-filled',
  'md-icon-odometer-filled',
  'md-icon-organization-filled',
  'md-icon-postcard-filled',
  'md-icon-receipts-filled',
  'md-icon-printer-filled',
  'md-icon-push-filled',
  'md-icon-s-check',
  'md-icon-receiving-filled',
  'md-icon-s-cooperation',
  'md-icon-s-comment',
  'md-icon-s-home',
  'md-icon-s-order',
  'md-icon-s-open',
  'md-icon-picture',
  'md-icon-s-tools',
  'md-icon-s-promotion',
  'md-icon-search-filled',
  'md-icon-shopping-cart-2-filled',
  'md-icon-share-2-filled',
  'md-icon-save-filled',
  'md-icon-sound-filled',
  'md-icon-spreadsheet-filled',
  'md-icon-star-on',
  'md-icon-sound-mute-filled',
  'md-icon-tickets-filled',
  'md-icon-theme-filled',
  'md-icon-sync-filled',
  'md-icon-takeaway-box-filled',
  'md-icon-timer-filled',
  'md-icon-tool-filled',
  'md-icon-truck-filled',
  'md-icon-unhappy-filled',
  'md-icon-turn-off-microphone-filled',
  'md-icon-user-solid',
  'md-icon-video-play-filled',
  'md-icon-video-camera-solid',
  'md-icon-view-filled',
  'md-icon-unlock-filled',
  'md-icon-delete-solid',
  'md-icon-column-list-filled',
  'md-icon-document-copy-filled',
  'md-icon-edit-filled',
  'md-icon-pie-chart-filled',
  'md-icon-hierarchical-list-filled',
  'md-icon-edit-filledbeifen',
  'md-icon-indent-list-filled',
  'md-icon-document-filled',
  'md-icon-circle-check',
  'md-icon-circle-close',
  'md-icon-disable-circle-outline',
  'md-icon-circle-plus-outline',
  'md-icon-info-outline',
  'md-icon-sand-clock-outline',
  'md-icon-remove-outline',
  'md-icon-question-line',
  'md-icon-zoom-in',
  'md-icon-time',
  'md-icon-zoom-out',
  'md-icon-time-filled',
  'md-icon-success',
  'md-icon-question',
  'md-icon-info',
  'md-icon-sand-clock-filled',
  'md-icon-circle-plus',
  'md-icon-disable-circle-filled',
  'md-icon-error',
  'md-icon-remove',
  'md-icon-zoom-in-filled',
  'md-icon-zoom-out-filled',
  'md-icon-d-caret',
  'md-icon-right-most1',
  'md-icon-left-most1',
  'md-icon-a-Downarrow',
  'md-icon-a-Rightarrow',
  'md-icon-a-Uparrow',
  'md-icon-a-Leftarrow',
  'md-icon-left',
  'md-icon-top',
  'md-icon-buttom',
  'md-icon-right',
  'md-icon-caret-right',
  'md-icon-caret-top',
  'md-icon-caret-bottom',
  'md-icon-caret-left',
  'md-icon-special_down',
  'md-icon-special_left',
  'md-icon-special_up',
  'md-icon-special_right',
  'md-icon-double-right',
  'md-icon-double-left',
  'md-icon-shrink-outlined',
  'md-icon-arrowsalt-outlined',
  'md-icon-swapLeft-outline',
  'md-icon-swapright-outline',
  'md-icon-left-most',
  'md-icon-right-most',
  'md-icon-d-arrow-left',
  'md-icon-d-arrow-right',
  'md-icon-sort',
  'md-icon-arrow-left',
  'md-icon-arrow-right',
  'md-icon-arrow-down',
  'md-icon-arrow-up',
  'md-icon-kongshuju',
];
